var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`justify-center leading-[1.7] flex gap-[12px] text-[14px] text-white px-[12px] py-[12px] lg:text-[16px] lg:py-[12px] lg:leading-[1.5] ${_vm.data.type}`},[_c('span',[_c('InfoIcon')],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }